export default __webpack_public_path__ + "static/SanFrancisco-db807dea97eeca1910438c3c239f7724.png";